module.exports = __webpack_public_path__ + "static/media/seventh_covered_bridge4.b755ea03.png";